export default "__VITE_ASSET__B7_Q2LcZ__"